import angular from 'angular';

var shopTooltip = function() {
 	return {
 		restrict: 'A',
 		link: function(scope, elem, attr) {
 			elem.tooltip({
        		trigger: 'hover',
        		placement: 'bottom'
        	});

        	scope.$on('$destroy', () => {
        		elem.tooltip('destroy');
        	});
 		}
 	};
 };

export default angular.module('app.toolTip', [])
	.directive('shopTooltip', shopTooltip)
	.name;